module.exports = __webpack_public_path__ + "images/branding/savemyhomeusa/logo.jpg";